import Dashboard from "./client/Dashboard";

const Client = {
    Dashboard
};

export default Client;